import React from 'react';
import { Box, Skeleton } from '@mui/material';

export default function MiniWebSessionCardSkeleton() {
  const gradientBackground = 'linear-gradient(270deg, rgba(219, 219, 219, 0.05) 0%, #DBDBDB 50%)';

  return (
    <Box
      sx={{
        width: '373px',
        height: '400px',
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 4px 40px 0px #FFDDC840',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: '100%',
          minHeight: '95px',
          borderRadius: '10px 10px 0px 0px',
          padding: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <Skeleton
            variant="text"
            width={143}
            height={17.5}
            sx={{
              borderRadius: '25px',
              background: gradientBackground,
            }}
          />
          <Skeleton
            variant="text"
            width={54}
            height={13.12}
            sx={{
              borderRadius: '18.75px',
              background: gradientBackground,
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
          }}
        >
          <Skeleton
            variant="circular"
            width={16}
            height={16}
            sx={{
              background: gradientBackground,
            }}
          />
          <Skeleton
            variant="rectangular"
            width={36}
            height={17.5}
            sx={{
              borderRadius: '25px',
              background: gradientBackground,
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
          justifyContent: 'space-between',
          padding: '20px 16px',
          gap: '2px',
        }}
      >
        <Skeleton
          variant="text"
          width={213}
          height={15}
          sx={{
            borderRadius: '21.25px',
            background: gradientBackground,
          }}
        />
        <Skeleton
          variant="text"
          width={180}
          height={15}
          sx={{
            borderRadius: '21.25px',
            background: gradientBackground,
          }}
        />
        <Skeleton
          variant="text"
          width={335}
          height={15}
          sx={{
            borderRadius: '21.25px',
            background: gradientBackground,
          }}
        />
        <Skeleton
          variant="text"
          width={299}
          height={15}
          sx={{
            borderRadius: '21.25px',
            background: gradientBackground,
          }}
        />
        <Skeleton
          variant="text"
          width={202}
          height={15}
          sx={{
            borderRadius: '21.25px',
            background: gradientBackground,
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
          marginTop: '120px',
        }}
      >
        <Skeleton
          variant="rectangular"
          width="90%"
          height={45}
          sx={{
            borderRadius: '15px',
            background: gradientBackground,
          }}
        />
      </Box>
    </Box>
  );
}
